import {
  Certification,
  CertificationRequest,
  GetCertificationsResponse,
} from "../../../types/api/certifications.type";
import { QueryParam, ResourceId } from "../../../types/api/generic.type";
import { createQueryParamString } from "../../../utils/queryParams.utils";
import httpClient from "../../client/HttpClient";

const CertificationsService = {
  async list(
    pageSize: number,
    pageNumber: number,
    queryParams?: QueryParam[],
    signal?: AbortSignal,
  ): Promise<GetCertificationsResponse> {
    const params = queryParams ? createQueryParamString(queryParams) : "";

    const response = await httpClient.get<GetCertificationsResponse>(
      `v1/certifications?pageSize=${pageSize}&pageNumber=${pageNumber}${params}`,
      { signal },
    );
    return response;
  },
  async get(certificationsId: string): Promise<Certification> {
    const response = await httpClient.get<Certification>(
      `v1/certifications/${certificationsId}`,
    );
    return response;
  },
  async add(body: CertificationRequest): Promise<ResourceId> {
    const response = await httpClient.post<CertificationRequest, ResourceId>(
      "v1/certifications",
      body,
    );
    return response;
  },
  async update(
    certificationsId: number,
    body: CertificationRequest,
  ): Promise<void> {
    await httpClient.put(`v1/certifications/${certificationsId}`, body);
  },
  async delete(certificationsId: number): Promise<void> {
    await httpClient.delete(`v1/certifications/${certificationsId}`);
  },
};

export default CertificationsService;
